export const SLIDE_DECK_URL =
  'https://docs.google.com/presentation/d/e/2PACX-1vTezgMfwMSMOTV1xAERxRqVY9TMX-bF-45w2v5gP4jbs8Wy1t_H3u5kTwkxNfQFcA/embed?start=false&loop=false&delayms=60000';

export const NASA_SPACE_APPS_WINNERS_URL =
  'https://www.nasa.gov/learning-resources/stem-engagement-at-nasa/nasa-international-space-apps-challenge-announces-2024-global-winners/';

export const NOMINATIM_SEARCH_URL =
  'https://nominatim.openstreetmap.org/search';

export const OPEN_METEO_FORECAST_URL = 'https://api.open-meteo.com/v1/forecast';

export const OPEN_METEO_ARCHIVE_URL =
  'https://archive-api.open-meteo.com/v1/archive';

export const GITHUB_REPO_URL =
  'https://github.com/Zernach/skyfi-mcp';
